// extracted by mini-css-extract-plugin
module.exports = {"heroContent":"_1Y3zN","truckBoxImage":"ClqcE","status-sold":"_1TJBJ","status-escrow":"_4qQbx","status-removed":"_39G2n","lineClamp":"_5jY-p","text_container":"_1WNFC"};